<!-- GeneralLayout provides standard padding for the layout.
     Views using this template should be built from scratch as
     the template only provides standard margin/padding without content. -->
<template>
  <div>
    <slot name="alert"></slot>
    <div class="container-content">
      <slot name="default"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GeneralLayout',
  components: {},

  props: {}
}
</script>
